import { render, staticRenderFns } from "./Localizacion.vue?vue&type=template&id=3c75ac72&"
import script from "./Localizacion.vue?vue&type=script&lang=js&"
export * from "./Localizacion.vue?vue&type=script&lang=js&"
import style0 from "./Localizacion.vue?vue&type=style&index=0&id=3c75ac72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports